import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Menu,
    MenuItem
} from "@mui/material";
import { Menu as MenuIcon, Logout, ArrowForwardIos } from '@mui/icons-material';

import { HeaderMenuListType, Setting, UserInfo } from "../../helpers";

import "./mobile-menu.scss";

interface MobileMenuProps {
    profileAccountId: string[];
    accountId: string;
    userInfo: UserInfo;
    menuItems: HeaderMenuListType[];
    logoutHandler: () => void;
    handleItemClick: (item: { name?: string; link: string; }) => void;
    setting: Setting;
};

const MobileMenu = ({ setting, userInfo, menuItems, logoutHandler, handleItemClick, accountId, profileAccountId }: MobileMenuProps) => {

    const { pathname } = useLocation();

    const [selectedItem, setSelectedItem] = useState<string | null>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClickItem = (item: { name?: string; link: string; }) => {
        handleItemClick(item);
        setSelectedItem(item.link);
        handleClose();
    };
    const handleLogout = () => {
        setSelectedItem(null);
        handleClose();
        logoutHandler();
    }

    useEffect(() => {
        if (pathname.includes("accounts") && pathname.split("/").length <= 3) {
            setSelectedItem("/accounts/");
        }
    }, [pathname]);

    return (
        <Box className="mobile-menu-wrapper" >
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                color="secondary"
                onClick={handleClick}
                className="menu-button"
            >
                <MenuIcon />
                <span className="menu-button-text">Menu</span>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                className={`menu-sub-menu ${open ? 'open' : 'closed'}`}
            >
                {
                    menuItems.map((item) =>
                        <MenuItem
                            sx={{ paddingTop: 0 }}
                            key={item.name}
                            classes={{ selected: 'menu-sub-selected' }}
                        >
                            {item.subMenu.length === 0 ? (
                                <Box
                                    className="icon-name"
                                    sx={pathname?.includes(item.link) ?
                                        { background: '#158CBA', color: "#fff" } :
                                        { background: 'inherit', color: "inherit" }
                                    }
                                    onClick={() => handleClickItem(item)}
                                >
                                    {item.icon}
                                    {item.name}
                                </Box>
                            ) : (
                                <Accordion
                                    defaultExpanded={true}
                                    elevation={0}
                                    disableGutters
                                >
                                    <AccordionSummary
                                        sx={{
                                            padding: 0,
                                            minHeight: 0,
                                        }}
                                        classes={{
                                            content: "custom-accordion"
                                        }}
                                    >
                                        <Box
                                            className="icon-name"
                                            sx={pathname?.includes(item.link) ?
                                                { background: '#158CBA', color: "#fff" } :
                                                { background: 'inherit', color: "inherit" }
                                            }
                                        >
                                            {item.icon}
                                            {item.name}
                                        </Box>
                                    </AccordionSummary>
                                    <AccordionDetails
                                        sx={{
                                            paddingLeft: 2,
                                            paddingY: 0
                                        }}
                                    >
                                        <ul style={{ padding: '0px' }}>
                                            {item.subMenu
                                                .filter(item => setting.show_account_application ? item : !item.link.includes("account-applications"))
                                                .map((subMenuItem) => (
                                                    <MenuItem
                                                        key={subMenuItem.name}
                                                        className="icon-name"
                                                        sx={{ color: (selectedItem === subMenuItem.link || pathname === `${item.link}/${accountId}${subMenuItem.link}`) ? "#158cba" : 'inherit' }}
                                                        onClick={() => handleClickItem(subMenuItem)}
                                                        classes={{ selected: 'menu-sub-selected' }}
                                                        disabled={userInfo.role == "User" && profileAccountId.length === 0 && accountId.length === 0 && item.link.includes('/accounts')}
                                                    >
                                                        <ArrowForwardIos />
                                                        {subMenuItem.name}
                                                    </MenuItem>
                                                )
                                                )}
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            )}
                        </MenuItem>
                    )
                }
                <MenuItem
                    sx={{ paddingTop: 0 }}
                    key="logout"
                    classes={{ selected: 'menu-sub-selected' }}
                >
                    <Box
                        className="icon-name"
                        sx={{ paddingY: userInfo.role !== "User" ? 1 : 0 }}
                        onClick={handleLogout}
                    >
                        <Logout /> Logout
                    </Box>
                </MenuItem>
            </Menu>
        </Box>
    )
}

export default MobileMenu;